module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login"
  }, [_c('form', {
    attrs: {
      "action": "",
      "method": "post",
      "name": "login_form"
    }
  }, [_c('div', {
    staticClass: "head-login"
  }, [_c('label', [_c('h3', [_vm._v("Log in")])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix layout-login input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-user"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "username",
      "id": "username",
      "placeholder": "username"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix layout-login input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-key"
  })]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "name": "password",
      "id": "password",
      "placeholder": "password"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix layout-btn"
  }, [_c('input', {
    staticClass: "btn btn-login",
    attrs: {
      "type": "submit",
      "name": "submit",
      "value": "Login",
      "onclick": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8a31c542!./~/vue-loader/lib/selector.js?type=template&index=0!./src/admin/components/index.vue
// module id = 590
// module chunks = 2